import { commonjsRequire as s0 } from "../../_virtual/_commonjs-dynamic-modules.es.js";
import { __module as n0 } from "../../_virtual/UTIF.es.js";
import { __require as v0 } from "../pako/index.es.js";
(function(t0) {
  (function() {
    var F = {};
    t0.exports = F;
    var U;
    typeof s0 == "function" ? U = v0() : U = self.pako;
    function z() {
      (typeof process > "u" || process.env.NODE_ENV == "development") && console.log.apply(console, arguments);
    }
    (function(E, a0) {
      (function() {
        var i = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(d) {
          return typeof d;
        } : function(d) {
          return d && typeof Symbol == "function" && d.constructor === Symbol && d !== Symbol.prototype ? "symbol" : typeof d;
        }, r = function() {
          function d(c) {
            this.message = "JPEG error: " + c;
          }
          return d.prototype = Error(), d.prototype.name = "JpegError", d.constructor = d;
        }(), a = function() {
          function d(c, o) {
            this.message = c, this.g = o;
          }
          return d.prototype = Error(), d.prototype.name = "DNLMarkerError", d.constructor = d;
        }();
        (function() {
          function d() {
            this.M = null, this.B = -1;
          }
          function c(n, v) {
            for (var h = 0, t = [], e, l, f = 16; 0 < f && !n[f - 1]; ) f--;
            t.push({ children: [], index: 0 });
            var _ = t[0], A;
            for (e = 0; e < f; e++) {
              for (l = 0; l < n[e]; l++) {
                for (_ = t.pop(), _.children[_.index] = v[h]; 0 < _.index; ) _ = t.pop();
                for (_.index++, t.push(_); t.length <= e; ) t.push(A = { children: [], index: 0 }), _.children[_.index] = A.children, _ = A;
                h++;
              }
              e + 1 < f && (t.push(A = { children: [], index: 0 }), _.children[_.index] = A.children, _ = A);
            }
            return t[0].children;
          }
          function o(n, v, h, t, e, l, f, _, A) {
            function D() {
              if (0 < P) return P--, C >> P & 1;
              if (C = n[v++], C === 255) {
                var O = n[v++];
                if (O) {
                  if (O === 220 && j) {
                    v += 2;
                    var Q = n[v++] << 8 | n[v++];
                    if (0 < Q && Q !== h.g) throw new a("Found DNL marker (0xFFDC) while parsing scan data", Q);
                  }
                  throw new r("unexpected marker " + (C << 8 | O).toString(16));
                }
              }
              return P = 7, C >>> 7;
            }
            function B(O) {
              for (; ; ) {
                if (O = O[D()], typeof O == "number") return O;
                if ((typeof O > "u" ? "undefined" : i(O)) !== "object") throw new r("invalid huffman sequence");
              }
            }
            function p(O) {
              for (var Q = 0; 0 < O; ) Q = Q << 1 | D(), O--;
              return Q;
            }
            function x(O) {
              if (O === 1) return D() === 1 ? 1 : -1;
              var Q = p(O);
              return Q >= 1 << O - 1 ? Q : Q + (-1 << O) + 1;
            }
            function y(O, Q) {
              var g = B(O.D);
              for (g = g === 0 ? 0 : x(g), O.a[Q] = O.m += g, g = 1; 64 > g; ) {
                var H = B(O.o), Y = H & 15;
                if (H >>= 4, Y === 0) {
                  if (15 > H) break;
                  g += 16;
                } else g += H, O.a[Q + w[g]] = x(Y), g++;
              }
            }
            function S(O, Q) {
              var g = B(O.D);
              g = g === 0 ? 0 : x(g) << A, O.a[Q] = O.m += g;
            }
            function N(O, Q) {
              O.a[Q] |= D() << A;
            }
            function G(O, Q) {
              if (0 < J) J--;
              else for (var g = l; g <= f; ) {
                var H = B(O.o), Y = H & 15;
                if (H >>= 4, Y === 0) {
                  if (15 > H) {
                    J = p(H) + (1 << H) - 1;
                    break;
                  }
                  g += 16;
                } else g += H, O.a[Q + w[g]] = x(Y) * (1 << A), g++;
              }
            }
            function L(O, Q) {
              for (var g = l, H = 0, Y; g <= f; ) {
                Y = Q + w[g];
                var m = 0 > O.a[Y] ? -1 : 1;
                switch (b) {
                  case 0:
                    if (H = B(O.o), Y = H & 15, H >>= 4, Y === 0) 15 > H ? (J = p(H) + (1 << H), b = 4) : (H = 16, b = 1);
                    else {
                      if (Y !== 1) throw new r("invalid ACn encoding");
                      $ = x(Y), b = H ? 2 : 3;
                    }
                    continue;
                  case 1:
                  case 2:
                    O.a[Y] ? O.a[Y] += m * (D() << A) : (H--, H === 0 && (b = b === 2 ? 3 : 0));
                    break;
                  case 3:
                    O.a[Y] ? O.a[Y] += m * (D() << A) : (O.a[Y] = $ << A, b = 0);
                    break;
                  case 4:
                    O.a[Y] && (O.a[Y] += m * (D() << A));
                }
                g++;
              }
              b === 4 && (J--, J === 0 && (b = 0));
            }
            for (var j = 9 < arguments.length && arguments[9] !== void 0 ? arguments[9] : !1, M = h.P, k = v, C = 0, P = 0, J = 0, b = 0, $, R = t.length, V, K, Z, q, T = h.S ? l === 0 ? _ === 0 ? S : N : _ === 0 ? G : L : y, X = 0, I = R === 1 ? t[0].c * t[0].l : M * h.O, r0, e0; X < I; ) {
              var i0 = e ? Math.min(I - X, e) : I;
              for (V = 0; V < R; V++) t[V].m = 0;
              if (J = 0, R === 1) {
                var W = t[0];
                for (q = 0; q < i0; q++) T(W, 64 * ((W.c + 1) * (X / W.c | 0) + X % W.c)), X++;
              } else for (q = 0; q < i0; q++) {
                for (V = 0; V < R; V++) for (W = t[V], r0 = W.h, e0 = W.j, K = 0; K < e0; K++) for (Z = 0; Z < r0; Z++) T(W, 64 * ((W.c + 1) * ((X / M | 0) * W.j + K) + (X % M * W.h + Z)));
                X++;
              }
              if (P = 0, (W = u(n, v)) && W.f && ((0, _util.warn)("decodeScan - unexpected MCU data, current marker is: " + W.f), v = W.offset), W = W && W.F, !W || 65280 >= W) throw new r("marker was not found");
              if (65488 <= W && 65495 >= W) v += 2;
              else break;
            }
            return (W = u(n, v)) && W.f && ((0, _util.warn)("decodeScan - unexpected Scan data, current marker is: " + W.f), v = W.offset), v - k;
          }
          function s(n, v) {
            for (var h = v.c, t = v.l, e = new Int16Array(64), l = 0; l < t; l++) for (var f = 0; f < h; f++) {
              var _ = 64 * ((v.c + 1) * l + f), A = e, D = v.G, B = v.a;
              if (!D) throw new r("missing required Quantization Table.");
              for (var p = 0; 64 > p; p += 8) {
                var x = B[_ + p], y = B[_ + p + 1], S = B[_ + p + 2], N = B[_ + p + 3], G = B[_ + p + 4], L = B[_ + p + 5], j = B[_ + p + 6], M = B[_ + p + 7];
                if (x *= D[p], !(y | S | N | G | L | j | M)) x = 5793 * x + 512 >> 10, A[p] = x, A[p + 1] = x, A[p + 2] = x, A[p + 3] = x, A[p + 4] = x, A[p + 5] = x, A[p + 6] = x, A[p + 7] = x;
                else {
                  y *= D[p + 1], S *= D[p + 2], N *= D[p + 3], G *= D[p + 4], L *= D[p + 5], j *= D[p + 6], M *= D[p + 7];
                  var k = 5793 * x + 128 >> 8, C = 5793 * G + 128 >> 8, P = S, J = j;
                  G = 2896 * (y - M) + 128 >> 8, M = 2896 * (y + M) + 128 >> 8, N <<= 4, L <<= 4, k = k + C + 1 >> 1, C = k - C, x = 3784 * P + 1567 * J + 128 >> 8, P = 1567 * P - 3784 * J + 128 >> 8, J = x, G = G + L + 1 >> 1, L = G - L, M = M + N + 1 >> 1, N = M - N, k = k + J + 1 >> 1, J = k - J, C = C + P + 1 >> 1, P = C - P, x = 2276 * G + 3406 * M + 2048 >> 12, G = 3406 * G - 2276 * M + 2048 >> 12, M = x, x = 799 * N + 4017 * L + 2048 >> 12, N = 4017 * N - 799 * L + 2048 >> 12, L = x, A[p] = k + M, A[p + 7] = k - M, A[p + 1] = C + L, A[p + 6] = C - L, A[p + 2] = P + N, A[p + 5] = P - N, A[p + 3] = J + G, A[p + 4] = J - G;
                }
              }
              for (D = 0; 8 > D; ++D) x = A[D], y = A[D + 8], S = A[D + 16], N = A[D + 24], G = A[D + 32], L = A[D + 40], j = A[D + 48], M = A[D + 56], y | S | N | G | L | j | M ? (k = 5793 * x + 2048 >> 12, C = 5793 * G + 2048 >> 12, P = S, J = j, G = 2896 * (y - M) + 2048 >> 12, M = 2896 * (y + M) + 2048 >> 12, k = (k + C + 1 >> 1) + 4112, C = k - C, x = 3784 * P + 1567 * J + 2048 >> 12, P = 1567 * P - 3784 * J + 2048 >> 12, J = x, G = G + L + 1 >> 1, L = G - L, M = M + N + 1 >> 1, N = M - N, k = k + J + 1 >> 1, J = k - J, C = C + P + 1 >> 1, P = C - P, x = 2276 * G + 3406 * M + 2048 >> 12, G = 3406 * G - 2276 * M + 2048 >> 12, M = x, x = 799 * N + 4017 * L + 2048 >> 12, N = 4017 * N - 799 * L + 2048 >> 12, L = x, x = k + M, M = k - M, y = C + L, j = C - L, S = P + N, L = P - N, N = J + G, G = J - G, x = 16 > x ? 0 : 4080 <= x ? 255 : x >> 4, y = 16 > y ? 0 : 4080 <= y ? 255 : y >> 4, S = 16 > S ? 0 : 4080 <= S ? 255 : S >> 4, N = 16 > N ? 0 : 4080 <= N ? 255 : N >> 4, G = 16 > G ? 0 : 4080 <= G ? 255 : G >> 4, L = 16 > L ? 0 : 4080 <= L ? 255 : L >> 4, j = 16 > j ? 0 : 4080 <= j ? 255 : j >> 4, M = 16 > M ? 0 : 4080 <= M ? 255 : M >> 4, B[_ + D] = x, B[_ + D + 8] = y, B[_ + D + 16] = S, B[_ + D + 24] = N, B[_ + D + 32] = G, B[_ + D + 40] = L, B[_ + D + 48] = j, B[_ + D + 56] = M) : (x = 5793 * x + 8192 >> 14, x = -2040 > x ? 0 : 2024 <= x ? 255 : x + 2056 >> 4, B[_ + D] = x, B[_ + D + 8] = x, B[_ + D + 16] = x, B[_ + D + 24] = x, B[_ + D + 32] = x, B[_ + D + 40] = x, B[_ + D + 48] = x, B[_ + D + 56] = x);
            }
            return v.a;
          }
          function u(n, v) {
            var h = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : v, t = n.length - 1;
            if (h = h < v ? h : v, v >= t) return null;
            var e = n[v] << 8 | n[v + 1];
            if (65472 <= e && 65534 >= e) return { f: null, F: e, offset: v };
            for (var l = n[h] << 8 | n[h + 1]; !(65472 <= l && 65534 >= l); ) {
              if (++h >= t) return null;
              l = n[h] << 8 | n[h + 1];
            }
            return { f: e.toString(16), F: l, offset: h };
          }
          var w = new Uint8Array([
            0,
            1,
            8,
            16,
            9,
            2,
            3,
            10,
            17,
            24,
            32,
            25,
            18,
            11,
            4,
            5,
            12,
            19,
            26,
            33,
            40,
            48,
            41,
            34,
            27,
            20,
            13,
            6,
            7,
            14,
            21,
            28,
            35,
            42,
            49,
            56,
            57,
            50,
            43,
            36,
            29,
            22,
            15,
            23,
            30,
            37,
            44,
            51,
            58,
            59,
            52,
            45,
            38,
            31,
            39,
            46,
            53,
            60,
            61,
            54,
            47,
            55,
            62,
            63
          ]);
          d.prototype = { parse: function(n) {
            function v() {
              var P = n[f] << 8 | n[f + 1];
              return f += 2, P;
            }
            function h() {
              var P = v();
              P = f + P - 2;
              var J = u(n, P, f);
              return J && J.f && ((0, _util.warn)("readDataBlock - incorrect length, current marker is: " + J.f), P = J.offset), P = n.subarray(f, P), f += P.length, P;
            }
            function t(P) {
              for (var J = Math.ceil(P.v / 8 / P.s), b = Math.ceil(P.g / 8 / P.u), $ = 0; $ < P.b.length; $++) {
                k = P.b[$];
                var R = Math.ceil(Math.ceil(P.v / 8) * k.h / P.s), V = Math.ceil(Math.ceil(P.g / 8) * k.j / P.u);
                k.a = new Int16Array(64 * b * k.j * (J * k.h + 1)), k.c = R, k.l = V;
              }
              P.P = J, P.O = b;
            }
            var e = (1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {}).N, l = e === void 0 ? null : e, f = 0, _ = null, A = 0;
            e = [];
            var D = [], B = [], p = v();
            if (p !== 65496) throw new r("SOI not found");
            for (p = v(); p !== 65497; ) {
              switch (p) {
                case 65504:
                case 65505:
                case 65506:
                case 65507:
                case 65508:
                case 65509:
                case 65510:
                case 65511:
                case 65512:
                case 65513:
                case 65514:
                case 65515:
                case 65516:
                case 65517:
                case 65518:
                case 65519:
                case 65534:
                  var x = h();
                  p === 65518 && x[0] === 65 && x[1] === 100 && x[2] === 111 && x[3] === 98 && x[4] === 101 && (_ = { version: x[5] << 8 | x[6], Y: x[7] << 8 | x[8], Z: x[9] << 8 | x[10], W: x[11] });
                  break;
                case 65499:
                  p = v() + f - 2;
                  for (var y; f < p; ) {
                    var S = n[f++], N = new Uint16Array(64);
                    if (S >> 4) if (S >> 4 === 1) for (x = 0; 64 > x; x++) y = w[x], N[y] = v();
                    else throw new r("DQT - invalid table spec");
                    else for (x = 0; 64 > x; x++) y = w[x], N[y] = n[f++];
                    e[S & 15] = N;
                  }
                  break;
                case 65472:
                case 65473:
                case 65474:
                  if (G) throw new r("Only single frame JPEGs supported");
                  v();
                  var G = {};
                  for (G.X = p === 65473, G.S = p === 65474, G.precision = n[f++], p = v(), G.g = l || p, G.v = v(), G.b = [], G.C = {}, x = n[f++], p = N = S = 0; p < x; p++) {
                    y = n[f];
                    var L = n[f + 1] >> 4, j = n[f + 1] & 15;
                    S < L && (S = L), N < j && (N = j), L = G.b.push({ h: L, j, T: n[f + 2], G: null }), G.C[y] = L - 1, f += 3;
                  }
                  G.s = S, G.u = N, t(G);
                  break;
                case 65476:
                  for (y = v(), p = 2; p < y; ) {
                    for (S = n[f++], N = new Uint8Array(16), x = L = 0; 16 > x; x++, f++) L += N[x] = n[f];
                    for (j = new Uint8Array(L), x = 0; x < L; x++, f++) j[x] = n[f];
                    p += 17 + L, (S >> 4 ? D : B)[S & 15] = c(N, j);
                  }
                  break;
                case 65501:
                  v();
                  var M = v();
                  break;
                case 65498:
                  for (x = ++A === 1 && !l, v(), S = n[f++], y = [], p = 0; p < S; p++) {
                    N = G.C[n[f++]];
                    var k = G.b[N];
                    N = n[f++], k.D = B[N >> 4], k.o = D[N & 15], y.push(k);
                  }
                  p = n[f++], S = n[f++], N = n[f++];
                  try {
                    var C = o(n, f, G, y, M, p, S, N >> 4, N & 15, x);
                    f += C;
                  } catch (P) {
                    if (P instanceof a) return (0, _util.warn)('Attempting to re-parse JPEG image using "scanLines" parameter found in DNL marker (0xFFDC) segment.'), this.parse(n, { N: P.g });
                    throw P;
                  }
                  break;
                case 65500:
                  f += 4;
                  break;
                case 65535:
                  n[f] !== 255 && f--;
                  break;
                default:
                  if (n[f - 3] === 255 && 192 <= n[f - 2] && 254 >= n[f - 2]) f -= 3;
                  else if ((x = u(n, f - 2)) && x.f) (0, _util.warn)("JpegImage.parse - unexpected data, current marker is: " + x.f), f = x.offset;
                  else throw new r("unknown marker " + p.toString(16));
              }
              p = v();
            }
            for (this.width = G.v, this.height = G.g, this.A = _, this.b = [], p = 0; p < G.b.length; p++)
              k = G.b[p], (M = e[k.T]) && (k.G = M), this.b.push({ R: s(G, k), U: k.h / G.s, V: k.j / G.u, c: k.c, l: k.l });
            this.i = this.b.length;
          }, L: function(n, v) {
            var h = this.width / n, t = this.height / v, e, l, f = this.b.length, _ = n * v * f, A = new Uint8ClampedArray(_), D = new Uint32Array(n);
            for (l = 0; l < f; l++) {
              var B = this.b[l], p = B.U * h, x = B.V * t, y = l, S = B.R, N = B.c + 1 << 3;
              for (e = 0; e < n; e++) B = 0 | e * p, D[e] = (B & 4294967288) << 3 | B & 7;
              for (p = 0; p < v; p++) for (B = 0 | p * x, B = N * (B & 4294967288) | (B & 7) << 3, e = 0; e < n; e++) A[y] = S[B + D[e]], y += f;
            }
            if (t = this.M) for (l = 0; l < _; ) for (h = B = 0; B < f; B++, l++, h += 2) A[l] = (A[l] * t[h] >> 8) + t[h + 1];
            return A;
          }, w: function() {
            return this.A ? !!this.A.W : this.i === 3 ? this.B !== 0 : this.B === 1;
          }, I: function(n) {
            for (var v, h, t, e = 0, l = n.length; e < l; e += 3) v = n[e], h = n[e + 1], t = n[e + 2], n[e] = v - 179.456 + 1.402 * t, n[e + 1] = v + 135.459 - 0.344 * h - 0.714 * t, n[e + 2] = v - 226.816 + 1.772 * h;
            return n;
          }, K: function(n) {
            for (var v, h, t, e, l = 0, f = 0, _ = n.length; f < _; f += 4) v = n[f], h = n[f + 1], t = n[f + 2], e = n[f + 3], n[l++] = -122.67195406894 + h * (-660635669420364e-19 * h + 437130475926232e-18 * t - 54080610064599e-18 * v + 48449797120281e-17 * e - 0.154362151871126) + t * (-957964378445773e-18 * t + 817076911346625e-18 * v - 0.00477271405408747 * e + 1.53380253221734) + v * (961250184130688e-18 * v - 0.00266257332283933 * e + 0.48357088451265) + e * (-336197177618394e-18 * e + 0.484791561490776), n[l++] = 107.268039397724 + h * (219927104525741e-19 * h - 640992018297945e-18 * t + 659397001245577e-18 * v + 426105652938837e-18 * e - 0.176491792462875) + t * (-778269941513683e-18 * t + 0.00130872261408275 * v + 770482631801132e-18 * e - 0.151051492775562) + v * (0.00126935368114843 * v - 0.00265090189010898 * e + 0.25802910206845) + e * (-318913117588328e-18 * e - 0.213742400323665), n[l++] = -20.810012546947 + h * (-570115196973677e-18 * h - 263409051004589e-19 * t + 0.0020741088115012 * v - 0.00288260236853442 * e + 0.814272968359295) + t * (-153496057440975e-19 * t - 132689043961446e-18 * v + 560833691242812e-18 * e - 0.195152027534049) + v * (0.00174418132927582 * v - 0.00255243321439347 * e + 0.116935020465145) + e * (-343531996510555e-18 * e + 0.24165260232407);
            return n.subarray(
              0,
              l
            );
          }, J: function(n) {
            for (var v, h, t, e = 0, l = n.length; e < l; e += 4) v = n[e], h = n[e + 1], t = n[e + 2], n[e] = 434.456 - v - 1.402 * t, n[e + 1] = 119.541 - v + 0.344 * h + 0.714 * t, n[e + 2] = 481.816 - v - 1.772 * h;
            return n;
          }, H: function(n) {
            for (var v, h, t, e, l = 0, f = 1 / 255, _ = 0, A = n.length; _ < A; _ += 4) v = n[_] * f, h = n[_ + 1] * f, t = n[_ + 2] * f, e = n[_ + 3] * f, n[l++] = 255 + v * (-4.387332384609988 * v + 54.48615194189176 * h + 18.82290502165302 * t + 212.25662451639585 * e - 285.2331026137004) + h * (1.7149763477362134 * h - 5.6096736904047315 * t - 17.873870861415444 * e - 5.497006427196366) + t * (-2.5217340131683033 * t - 21.248923337353073 * e + 17.5119270841813) - e * (21.86122147463605 * e + 189.48180835922747), n[l++] = 255 + v * (8.841041422036149 * v + 60.118027045597366 * h + 6.871425592049007 * t + 31.159100130055922 * e - 79.2970844816548) + h * (-15.310361306967817 * h + 17.575251261109482 * t + 131.35250912493976 * e - 190.9453302588951) + t * (4.444339102852739 * t + 9.8632861493405 * e - 24.86741582555878) - e * (20.737325471181034 * e + 187.80453709719578), n[l++] = 255 + v * (0.8842522430003296 * v + 8.078677503112928 * h + 30.89978309703729 * t - 0.23883238689178934 * e - 14.183576799673286) + h * (10.49593273432072 * h + 63.02378494754052 * t + 50.606957656360734 * e - 112.23884253719248) + t * (0.03296041114873217 * t + 115.60384449646641 * e - 193.58209356861505) - e * (22.33816807309886 * e + 180.12613974708367);
            return n.subarray(0, l);
          }, getData: function(n, v, h) {
            if (4 < this.i) throw new r("Unsupported color mode");
            if (n = this.L(n, v), this.i === 1 && h) {
              h = n.length, v = new Uint8ClampedArray(3 * h);
              for (var t = 0, e = 0; e < h; e++) {
                var l = n[e];
                v[t++] = l, v[t++] = l, v[t++] = l;
              }
              return v;
            }
            if (this.i === 3 && this.w()) return this.I(n);
            if (this.i === 4) {
              if (this.w()) return h ? this.K(n) : this.J(n);
              if (h) return this.H(n);
            }
            return n;
          } }, E.JpegDecoder = d;
        })();
      })(), E.encodeImage = function(i, r, a, d) {
        var c = {
          t256: [r],
          t257: [a],
          t258: [8, 8, 8, 8],
          t259: [1],
          t262: [2],
          t273: [1e3],
          // strips offset
          t277: [4],
          t278: [a],
          /* rows per strip */
          t279: [r * a * 4],
          // strip byte counts
          t282: [1],
          t283: [1],
          t284: [1],
          t286: [0],
          t287: [0],
          t296: [1],
          t305: ["Photopea (UTIF.js)"],
          t338: [1]
        };
        if (d) for (var o in d) c[o] = d[o];
        for (var s = new Uint8Array(E.encode([c])), u = new Uint8Array(i), w = new Uint8Array(1e3 + r * a * 4), o = 0; o < s.length; o++) w[o] = s[o];
        for (var o = 0; o < u.length; o++) w[1e3 + o] = u[o];
        return w.buffer;
      }, E.encode = function(i) {
        var r = new Uint8Array(2e4), a = 4, d = E._binBE;
        r[0] = 77, r[1] = 77, r[3] = 42;
        var c = 8;
        d.writeUint(r, a, c), a += 4;
        for (var o = 0; o < i.length; o++) {
          var s = E._writeIFD(d, r, c, i[o]);
          c = s[1], o < i.length - 1 && d.writeUint(r, s[0], c);
        }
        return r.slice(0, c).buffer;
      }, E.decode = function(i) {
        E.decode._decodeG3.allow2D = null;
        var r = new Uint8Array(i), a = 0, d = E._binBE.readASCII(r, a, 2);
        a += 2;
        var c = d == "II" ? E._binLE : E._binBE;
        c.readUshort(r, a), a += 2;
        var o = c.readUint(r, a);
        a += 4;
        for (var s = []; ; ) {
          var u = E._readIFD(c, r, o, s, 0, !1);
          if (o = c.readUint(r, u), o == 0) break;
        }
        return s;
      }, E.decodeImage = function(i, r, a) {
        var d = new Uint8Array(i), c = E._binBE.readASCII(d, 0, 2);
        if (r.t256 != null) {
          r.isLE = c == "II", r.width = r.t256[0], r.height = r.t257[0];
          var o = r.t259 ? r.t259[0] : 1, s = r.t266 ? r.t266[0] : 1;
          r.t284 && r.t284[0] == 2 && z("PlanarConfiguration 2 should not be used!");
          var u;
          r.t258 ? u = Math.min(32, r.t258[0]) * r.t258.length : u = r.t277 ? r.t277[0] : 1, o == 1 && r.t279 != null && r.t278 && r.t262[0] == 32803 && (u = Math.round(r.t279[0] * 8 / (r.width * r.t278[0])));
          var w = Math.ceil(r.width * u / 8) * 8, n = r.t273;
          n == null && (n = r.t324);
          var v = r.t279;
          o == 1 && n.length == 1 && (v = [r.height * (w >>> 3)]), v == null && (v = r.t325);
          var h = new Uint8Array(r.height * (w >>> 3)), t = 0;
          if (r.t322 != null) {
            for (var e = r.t322[0], l = r.t323[0], f = Math.floor((r.width + e - 1) / e), _ = Math.floor((r.height + l - 1) / l), A = new Uint8Array(Math.ceil(e * l * u / 8) | 0), D = 0; D < _; D++)
              for (var B = 0; B < f; B++) {
                for (var p = D * f + B, x = 0; x < A.length; x++) A[x] = 0;
                E.decode._decompress(r, a, d, n[p], v[p], o, A, 0, s), o == 6 ? h = A : E._copyTile(A, Math.ceil(e * u / 8) | 0, l, h, Math.ceil(r.width * u / 8) | 0, r.height, Math.ceil(B * e * u / 8) | 0, D * l);
              }
            t = h.length * 8;
          } else {
            var y = r.t278 ? r.t278[0] : r.height;
            y = Math.min(y, r.height);
            for (var p = 0; p < n.length; p++)
              E.decode._decompress(r, a, d, n[p], v[p], o, h, Math.ceil(t / 8) | 0, s), t += w * y;
            t = Math.min(t, h.length * 8);
          }
          r.data = new Uint8Array(h.buffer, 0, Math.ceil(t / 8) | 0);
        }
      }, E.decode._decompress = function(i, r, a, d, c, o, s, u, w) {
        if (o == 1 || c == s.length && o != 32767) for (var n = 0; n < c; n++) s[u + n] = a[d + n];
        else if (o == 3) E.decode._decodeG3(a, d, c, s, u, i.width, w);
        else if (o == 4) E.decode._decodeG4(a, d, c, s, u, i.width, w);
        else if (o == 5) E.decode._decodeLZW(a, d, s, u);
        else if (o == 6) E.decode._decodeOldJPEG(i, a, d, c, s, u);
        else if (o == 7) E.decode._decodeNewJPEG(i, a, d, c, s, u);
        else if (o == 8)
          for (var v = new Uint8Array(a.buffer, d, c), h = a0.inflate(v), t = 0; t < h.length; t++) s[u + t] = h[t];
        else o == 32767 ? E.decode._decodeARW(i, a, d, c, s, u) : o == 32773 ? E.decode._decodePackBits(a, d, c, s, u) : o == 32809 ? E.decode._decodeThunder(a, d, c, s, u) : o == 34713 ? E.decode._decodeNikon(i, r, a, d, c, s, u) : z("Unknown compression", o);
        var e = i.t258 ? Math.min(32, i.t258[0]) : 1, l = i.t277 ? i.t277[0] : 1, f = e * l >>> 3, _ = i.t278 ? i.t278[0] : i.height, A = Math.ceil(e * l * i.width / 8);
        if (e == 16 && !i.isLE && i.t33422 == null)
          for (var D = 0; D < _; D++)
            for (var B = u + D * A, p = 1; p < A; p += 2) {
              var x = s[B + p];
              s[B + p] = s[B + p - 1], s[B + p - 1] = x;
            }
        if (i.t317 && i.t317[0] == 2)
          for (var D = 0; D < _; D++) {
            var y = u + D * A;
            if (e == 16) for (var n = f; n < A; n += 2) {
              var S = (s[y + n + 1] << 8 | s[y + n]) + (s[y + n - f + 1] << 8 | s[y + n - f]);
              s[y + n] = S & 255, s[y + n + 1] = S >>> 8 & 255;
            }
            else if (l == 3) for (var n = 3; n < A; n += 3)
              s[y + n] = s[y + n] + s[y + n - 3] & 255, s[y + n + 1] = s[y + n + 1] + s[y + n - 2] & 255, s[y + n + 2] = s[y + n + 2] + s[y + n - 1] & 255;
            else for (var n = f; n < A; n++) s[y + n] = s[y + n] + s[y + n - f] & 255;
          }
      }, E.decode._ljpeg_diff = function(i, r, a) {
        var d = E.decode._getbithuff, c, o;
        return c = d(i, r, a[0], a), o = d(i, r, c, 0), o & 1 << c - 1 || (o -= (1 << c) - 1), o;
      }, E.decode._decodeARW = function(i, r, a, d, c, o) {
        var s = i.t256[0], u = i.t257[0], w = i.t258[0], n = i.isLE ? E._binLE : E._binBE, v = s * u == d || s * u * 1.5 == d;
        if (!v) {
          u += 8;
          var h = [a, 0, 0, 0], t = new Uint16Array(32770), e = [
            3857,
            3856,
            3599,
            3342,
            3085,
            2828,
            2571,
            2314,
            2057,
            1800,
            1543,
            1286,
            1029,
            772,
            771,
            768,
            514,
            513
          ], b, l, f, G, N, _ = 0, A = E.decode._ljpeg_diff;
          for (t[0] = 15, f = b = 0; b < 18; b++)
            for (var D = 32768 >>> (e[b] >>> 8), l = 0; l < D; l++) t[++f] = e[b];
          for (G = s; G--; )
            for (N = 0; N < u + 1; N += 2)
              if (N == u && (N = 1), _ += A(r, h, t), N < u) {
                var B = _ & 4095;
                E.decode._putsF(c, (N * s + G) * w, B << 16 - w);
              }
          return;
        }
        if (s * u * 1.5 == d) {
          for (var b = 0; b < d; b += 3) {
            var p = r[a + b + 0], x = r[a + b + 1], y = r[a + b + 2];
            c[o + b] = x << 4 | p >>> 4, c[o + b + 1] = p << 4 | y >>> 4, c[o + b + 2] = y << 4 | x >>> 4;
          }
          return;
        }
        var S = new Uint16Array(16), N, G, L, j, M, k, C, P, J, b, $, R = new Uint8Array(s + 1);
        for (N = 0; N < u; N++) {
          for (var V = 0; V < s; V++) R[V] = r[a++];
          for ($ = 0, G = 0; G < s - 30; $ += 16) {
            for (j = 2047 & (L = n.readUint(R, $)), M = 2047 & L >>> 11, k = 15 & L >>> 22, C = 15 & L >>> 26, P = 0; P < 4 && 128 << P <= j - M; P++) ;
            for (J = 30, b = 0; b < 16; b++)
              b == k ? S[b] = j : b == C ? S[b] = M : (S[b] = ((n.readUshort(R, $ + (J >> 3)) >>> (J & 7) & 127) << P) + M, S[b] > 2047 && (S[b] = 2047), J += 7);
            for (b = 0; b < 16; b++, G += 2) {
              var B = S[b] << 1;
              E.decode._putsF(c, (N * s + G) * w, B << 16 - w);
            }
            G -= G & 1 ? 1 : 31;
          }
        }
      }, E.decode._decodeNikon = function(i, r, a, d, c, o, s) {
        var u = [
          [
            0,
            0,
            1,
            5,
            1,
            1,
            1,
            1,
            1,
            1,
            2,
            0,
            0,
            0,
            0,
            0,
            0,
            /* 12-bit lossy */
            5,
            4,
            3,
            6,
            2,
            7,
            1,
            0,
            8,
            9,
            11,
            10,
            12
          ],
          [
            0,
            0,
            1,
            5,
            1,
            1,
            1,
            1,
            1,
            1,
            2,
            0,
            0,
            0,
            0,
            0,
            0,
            /* 12-bit lossy after split */
            57,
            90,
            56,
            39,
            22,
            5,
            4,
            3,
            2,
            1,
            0,
            11,
            12,
            12
          ],
          [
            0,
            0,
            1,
            4,
            2,
            3,
            1,
            2,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            /* 12-bit lossless */
            5,
            4,
            6,
            3,
            7,
            2,
            8,
            1,
            9,
            0,
            10,
            11,
            12
          ],
          [
            0,
            0,
            1,
            4,
            3,
            1,
            1,
            1,
            1,
            1,
            2,
            0,
            0,
            0,
            0,
            0,
            0,
            /* 14-bit lossy */
            5,
            6,
            4,
            7,
            8,
            3,
            9,
            2,
            1,
            0,
            10,
            11,
            12,
            13,
            14
          ],
          [
            0,
            0,
            1,
            5,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            2,
            0,
            0,
            0,
            0,
            0,
            /* 14-bit lossy after split */
            8,
            92,
            75,
            58,
            41,
            7,
            6,
            5,
            4,
            3,
            2,
            1,
            0,
            13,
            14
          ],
          [
            0,
            0,
            1,
            4,
            2,
            2,
            3,
            1,
            2,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            /* 14-bit lossless */
            7,
            6,
            8,
            5,
            9,
            4,
            10,
            3,
            11,
            12,
            2,
            0,
            1,
            13,
            14
          ]
        ], w = i.t256[0], n = i.t257[0], v = i.t258[0], h = 0, t = 0, e = E.decode._make_decoder, l = E.decode._getbithuff, f = r[0].exifIFD.makerNote, _ = f.t150 ? f.t150 : f.t140, A = 0, D = _[A++], B = _[A++];
        (D == 73 || B == 88) && (A += 2110), D == 70 && (h = 2), v == 14 && (h += 3);
        for (var p = [[0, 0], [0, 0]], x = i.isLE ? E._binLE : E._binBE, L = 0; L < 2; L++) for (var y = 0; y < 2; y++)
          p[L][y] = x.readShort(_, A), A += 2;
        var S = 1 << v & 32767, N = 0, G = x.readShort(_, A);
        A += 2, G > 1 && (N = Math.floor(S / (G - 1))), D == 68 && B == 32 && N > 0 && (t = x.readShort(_, 562));
        var L, j, M, k, C, P, J = [0, 0], b = e(u[h]), $ = [d, 0, 0, 0];
        for (j = 0; j < n; j++)
          for (t && j == t && (b = e(u[h + 1])), M = 0; M < w; M++) {
            L = l(a, $, b[0], b), k = L & 15, C = L >>> 4, P = (l(a, $, k - C, 0) << 1) + 1 << C >>> 1, P & 1 << k - 1 || (P -= (1 << k) - (C == 0 ? 1 : 0)), M < 2 ? J[M] = p[j & 1][M] += P : J[M & 1] += P;
            var R = Math.min(Math.max(J[M & 1], 0), (1 << v) - 1), V = (j * w + M) * v;
            E.decode._putsF(o, V, R << 16 - v);
          }
      }, E.decode._putsF = function(i, r, a) {
        a = a << 8 - (r & 7);
        var d = r >>> 3;
        i[d] |= a >>> 16, i[d + 1] |= a >>> 8, i[d + 2] |= a;
      }, E.decode._getbithuff = function(i, r, a, d) {
        var c = 0;
        E.decode._get_byte;
        var o, s = r[0], u = r[1], w = r[2], n = r[3];
        if (a == 0 || w < 0) return 0;
        for (; !n && w < a && (o = i[s++]) != -1 && !(n = c); )
          u = (u << 8) + o, w += 8;
        if (o = u << 32 - w >>> 32 - a, d ? (w -= d[o + 1] >>> 8, o = d[o + 1] & 255) : w -= a, w < 0) throw "e";
        return r[0] = s, r[1] = u, r[2] = w, r[3] = n, o;
      }, E.decode._make_decoder = function(i) {
        var r, a, d, c, o, s = [];
        for (r = 16; r != 0 && !i[r]; r--) ;
        var u = 17;
        for (s[0] = r, d = a = 1; a <= r; a++)
          for (c = 0; c < i[a]; c++, ++u)
            for (o = 0; o < 1 << r - a; o++)
              d <= 1 << r && (s[d++] = a << 8 | i[u]);
        return s;
      }, E.decode._decodeNewJPEG = function(i, r, a, d, c, o) {
        var s = i.t347, u = s ? s.length : 0, w = new Uint8Array(u + d);
        if (s) {
          for (var n = 216, v = 217, h = 0, t = 0; t < u - 1 && !(s[t] == 255 && s[t + 1] == v); t++)
            w[h++] = s[t];
          var e = r[a], l = r[a + 1];
          (e != 255 || l != n) && (w[h++] = e, w[h++] = l);
          for (var t = 2; t < d; t++) w[h++] = r[a + t];
        } else for (var t = 0; t < d; t++) w[t] = r[a + t];
        if (i.t262[0] == 32803 || i.t262[0] == 34892) {
          var f = i.t258[0], _ = E.LosslessJpegDecode(w), A = _.length;
          if (f == 16)
            if (i.isLE) for (var t = 0; t < A; t++)
              c[o + (t << 1)] = _[t] & 255, c[o + (t << 1) + 1] = _[t] >>> 8;
            else for (var t = 0; t < A; t++)
              c[o + (t << 1)] = _[t] >>> 8, c[o + (t << 1) + 1] = _[t] & 255;
          else if (f == 14 || f == 12)
            for (var D = 16 - f, t = 0; t < A; t++) E.decode._putsF(c, t * f, _[t] << D);
          else throw new Error("unsupported bit depth " + f);
        } else {
          var B = new E.JpegDecoder();
          B.parse(w);
          for (var p = B.getData(B.width, B.height), t = 0; t < p.length; t++) c[o + t] = p[t];
        }
        i.t262[0] == 6 && (i.t262[0] = 2);
      }, E.decode._decodeOldJPEGInit = function(i, r, a, d) {
        var c = 216, o = 219, s = 196, u = 221, w = 192, n = 218, v = 0, h = 0, t, e, l = !1, f, _, A, D = i.t513, B = D ? D[0] : 0, p = i.t514, x = p ? p[0] : 0, y = i.t324 || i.t273 || D, S = i.t530, N = 0, G = 0, L = i.t277 ? i.t277[0] : 1, j = i.t515;
        if (y && (h = y[0], l = y.length > 1), !l) {
          if (r[a] == 255 && r[a + 1] == c) return { jpegOffset: a };
          if (D != null && (r[a + B] == 255 && r[a + B + 1] == c ? v = a + B : z("JPEGInterchangeFormat does not point to SOI"), p == null ? z("JPEGInterchangeFormatLength field is missing") : (B >= h || B + x <= h) && z("JPEGInterchangeFormatLength field value is invalid"), v != null))
            return { jpegOffset: v };
        }
        if (S != null && (N = S[0], G = S[1]), D != null && p != null)
          if (x >= 2 && B + x <= h) {
            for (r[a + B + x - 2] == 255 && r[a + B + x - 1] == c ? t = new Uint8Array(x - 2) : t = new Uint8Array(x), f = 0; f < t.length; f++) t[f] = r[a + B + f];
            z("Incorrect JPEG interchange format: using JPEGInterchangeFormat offset to derive tables");
          } else z("JPEGInterchangeFormat+JPEGInterchangeFormatLength > offset to first strip or tile");
        if (t == null) {
          var M = 0, k = [];
          k[M++] = 255, k[M++] = c;
          var C = i.t519;
          if (C == null) throw new Error("JPEGQTables tag is missing");
          for (f = 0; f < C.length; f++)
            for (k[M++] = 255, k[M++] = o, k[M++] = 0, k[M++] = 67, k[M++] = f, _ = 0; _ < 64; _++) k[M++] = r[a + C[f] + _];
          for (A = 0; A < 2; A++) {
            var P = i[A == 0 ? "t520" : "t521"];
            if (P == null) throw new Error((A == 0 ? "JPEGDCTables" : "JPEGACTables") + " tag is missing");
            for (f = 0; f < P.length; f++) {
              k[M++] = 255, k[M++] = s;
              var J = 19;
              for (_ = 0; _ < 16; _++) J += r[a + P[f] + _];
              for (k[M++] = J >>> 8, k[M++] = J & 255, k[M++] = f | A << 4, _ = 0; _ < 16; _++) k[M++] = r[a + P[f] + _];
              for (_ = 0; _ < J; _++) k[M++] = r[a + P[f] + 16 + _];
            }
          }
          if (k[M++] = 255, k[M++] = w, k[M++] = 0, k[M++] = 8 + 3 * L, k[M++] = 8, k[M++] = i.height >>> 8 & 255, k[M++] = i.height & 255, k[M++] = i.width >>> 8 & 255, k[M++] = i.width & 255, k[M++] = L, L == 1)
            k[M++] = 1, k[M++] = 17, k[M++] = 0;
          else for (f = 0; f < 3; f++)
            k[M++] = f + 1, k[M++] = f != 0 ? 17 : (N & 15) << 4 | G & 15, k[M++] = f;
          j != null && j[0] != 0 && (k[M++] = 255, k[M++] = u, k[M++] = 0, k[M++] = 4, k[M++] = j[0] >>> 8 & 255, k[M++] = j[0] & 255), t = new Uint8Array(k);
        }
        var b = -1;
        for (f = 0; f < t.length - 1; ) {
          if (t[f] == 255 && t[f + 1] == w) {
            b = f;
            break;
          }
          f++;
        }
        if (b == -1) {
          var $ = new Uint8Array(t.length + 10 + 3 * L);
          $.set(t);
          var R = t.length;
          if (b = t.length, t = $, t[R++] = 255, t[R++] = w, t[R++] = 0, t[R++] = 8 + 3 * L, t[R++] = 8, t[R++] = i.height >>> 8 & 255, t[R++] = i.height & 255, t[R++] = i.width >>> 8 & 255, t[R++] = i.width & 255, t[R++] = L, L == 1)
            t[R++] = 1, t[R++] = 17, t[R++] = 0;
          else for (f = 0; f < 3; f++)
            t[R++] = f + 1, t[R++] = f != 0 ? 17 : (N & 15) << 4 | G & 15, t[R++] = f;
        }
        if (r[h] == 255 && r[h + 1] == n) {
          var V = r[h + 2] << 8 | r[h + 3];
          for (e = new Uint8Array(V + 2), e[0] = r[h], e[1] = r[h + 1], e[2] = r[h + 2], e[3] = r[h + 3], f = 0; f < V - 2; f++) e[f + 4] = r[h + f + 4];
        } else {
          e = new Uint8Array(8 + 2 * L);
          var K = 0;
          if (e[K++] = 255, e[K++] = n, e[K++] = 0, e[K++] = 6 + 2 * L, e[K++] = L, L == 1)
            e[K++] = 1, e[K++] = 0;
          else for (f = 0; f < 3; f++)
            e[K++] = f + 1, e[K++] = f << 4 | f;
          e[K++] = 0, e[K++] = 63, e[K++] = 0;
        }
        return { jpegOffset: a, tables: t, sosMarker: e, sofPosition: b };
      }, E.decode._decodeOldJPEG = function(i, r, a, d, c, o) {
        var s, u, w, n, v, h = E.decode._decodeOldJPEGInit(i, r, a, d);
        if (h.jpegOffset != null)
          for (u = a + d - h.jpegOffset, n = new Uint8Array(u), s = 0; s < u; s++) n[s] = r[h.jpegOffset + s];
        else {
          for (w = h.tables.length, n = new Uint8Array(w + h.sosMarker.length + d + 2), n.set(h.tables), v = w, n[h.sofPosition + 5] = i.height >>> 8 & 255, n[h.sofPosition + 6] = i.height & 255, n[h.sofPosition + 7] = i.width >>> 8 & 255, n[h.sofPosition + 8] = i.width & 255, (r[a] != 255 || r[a + 1] != SOS) && (n.set(h.sosMarker, v), v += sosMarker.length), s = 0; s < d; s++) n[v++] = r[a + s];
          n[v++] = 255, n[v++] = EOI;
        }
        var t = new E.JpegDecoder();
        t.parse(n);
        for (var e = t.getData(t.width, t.height), s = 0; s < e.length; s++) c[o + s] = e[s];
        i.t262 && i.t262[0] == 6 && (i.t262[0] = 2);
      }, E.decode._decodePackBits = function(i, r, a, d, c) {
        for (var o = new Int8Array(i.buffer), s = new Int8Array(d.buffer), u = r + a; r < u; ) {
          var w = o[r];
          if (r++, w >= 0 && w < 128) for (var n = 0; n < w + 1; n++)
            s[c] = o[r], c++, r++;
          if (w >= -127 && w < 0) {
            for (var n = 0; n < -w + 1; n++)
              s[c] = o[r], c++;
            r++;
          }
        }
      }, E.decode._decodeThunder = function(i, r, a, d, c) {
        for (var o = [0, 1, 0, -1], s = [0, 1, 2, 3, 0, -3, -2, -1], u = r + a, w = c * 2, n = 0; r < u; ) {
          var v = i[r], h = v >>> 6, t = v & 63;
          if (r++, h == 3 && (n = t & 15, d[w >>> 1] |= n << 4 * (1 - w & 1), w++), h == 0) for (var e = 0; e < t; e++)
            d[w >>> 1] |= n << 4 * (1 - w & 1), w++;
          if (h == 2) for (var e = 0; e < 2; e++) {
            var l = t >>> 3 * (1 - e) & 7;
            l != 4 && (n += s[l], d[w >>> 1] |= n << 4 * (1 - w & 1), w++);
          }
          if (h == 1) for (var e = 0; e < 3; e++) {
            var l = t >>> 2 * (2 - e) & 3;
            l != 2 && (n += o[l], d[w >>> 1] |= n << 4 * (1 - w & 1), w++);
          }
        }
      }, E.decode._dmap = { 1: 0, "011": 1, "000011": 2, "0000011": 3, "010": -1, "000010": -2, "0000010": -3 }, E.decode._lens = function() {
        var i = function(w, n, v, h) {
          for (var t = 0; t < n.length; t++) w[n[t]] = v + t * h;
        }, r = "00110101,000111,0111,1000,1011,1100,1110,1111,10011,10100,00111,01000,001000,000011,110100,110101,101010,101011,0100111,0001100,0001000,0010111,0000011,0000100,0101000,0101011,0010011,0100100,0011000,00000010,00000011,00011010,00011011,00010010,00010011,00010100,00010101,00010110,00010111,00101000,00101001,00101010,00101011,00101100,00101101,00000100,00000101,00001010,00001011,01010010,01010011,01010100,01010101,00100100,00100101,01011000,01011001,01011010,01011011,01001010,01001011,00110010,00110011,00110100", a = "0000110111,010,11,10,011,0011,0010,00011,000101,000100,0000100,0000101,0000111,00000100,00000111,000011000,0000010111,0000011000,0000001000,00001100111,00001101000,00001101100,00000110111,00000101000,00000010111,00000011000,000011001010,000011001011,000011001100,000011001101,000001101000,000001101001,000001101010,000001101011,000011010010,000011010011,000011010100,000011010101,000011010110,000011010111,000001101100,000001101101,000011011010,000011011011,000001010100,000001010101,000001010110,000001010111,000001100100,000001100101,000001010010,000001010011,000000100100,000000110111,000000111000,000000100111,000000101000,000001011000,000001011001,000000101011,000000101100,000001011010,000001100110,000001100111", d = "11011,10010,010111,0110111,00110110,00110111,01100100,01100101,01101000,01100111,011001100,011001101,011010010,011010011,011010100,011010101,011010110,011010111,011011000,011011001,011011010,011011011,010011000,010011001,010011010,011000,010011011", c = "0000001111,000011001000,000011001001,000001011011,000000110011,000000110100,000000110101,0000001101100,0000001101101,0000001001010,0000001001011,0000001001100,0000001001101,0000001110010,0000001110011,0000001110100,0000001110101,0000001110110,0000001110111,0000001010010,0000001010011,0000001010100,0000001010101,0000001011010,0000001011011,0000001100100,0000001100101", o = "00000001000,00000001100,00000001101,000000010010,000000010011,000000010100,000000010101,000000010110,000000010111,000000011100,000000011101,000000011110,000000011111";
        r = r.split(","), a = a.split(","), d = d.split(","), c = c.split(","), o = o.split(",");
        var s = {}, u = {};
        return i(s, r, 0, 1), i(s, d, 64, 64), i(s, o, 1792, 64), i(u, a, 0, 1), i(u, c, 64, 64), i(u, o, 1792, 64), [s, u];
      }(), E.decode._decodeG4 = function(i, r, a, d, c, o, s) {
        for (var u = E.decode, w = r << 3, n = 0, v = "", h = [], t = [], e = 0; e < o; e++) t.push(0);
        t = u._makeDiff(t);
        for (var l = 0, f = 0, _ = 0, A = 0, D = 0, B = 0, p = "", x = 0, y = Math.ceil(o / 8) * 8; w >>> 3 < r + a; ) {
          _ = u._findDiff(t, l + (l == 0 ? 0 : 1), 1 - D), A = u._findDiff(t, _, D);
          var S = 0;
          if (s == 1 && (S = i[w >>> 3] >>> 7 - (w & 7) & 1), s == 2 && (S = i[w >>> 3] >>> (w & 7) & 1), w++, v += S, p == "H") {
            if (u._lens[D][v] != null) {
              var N = u._lens[D][v];
              v = "", n += N, N < 64 && (u._addNtimes(h, n, D), l += n, D = 1 - D, n = 0, x--, x == 0 && (p = ""));
            }
          } else
            v == "0001" && (v = "", u._addNtimes(h, A - l, D), l = A), v == "001" && (v = "", p = "H", x = 2), u._dmap[v] != null && (f = _ + u._dmap[v], u._addNtimes(h, f - l, D), l = f, v = "", D = 1 - D);
          h.length == o && p == "" && (u._writeBits(h, d, c * 8 + B * y), D = 0, B++, l = 0, t = u._makeDiff(h), h = []);
        }
      }, E.decode._findDiff = function(i, r, a) {
        for (var d = 0; d < i.length; d += 2) if (i[d] >= r && i[d + 1] == a) return i[d];
      }, E.decode._makeDiff = function(i) {
        var r = [];
        i[0] == 1 && r.push(0, 1);
        for (var a = 1; a < i.length; a++) i[a - 1] != i[a] && r.push(a, i[a]);
        return r.push(i.length, 0, i.length, 1), r;
      }, E.decode._decodeG3 = function(i, r, a, d, c, o, s) {
        for (var u = E.decode, w = r << 3, n = 0, v = "", h = [], t = [], e = 0; e < o; e++) h.push(0);
        for (var l = 0, f = 0, _ = 0, A = 0, D = 0, B = -1, p = "", x = 0, y = !1, S = Math.ceil(o / 8) * 8; w >>> 3 < r + a; ) {
          _ = u._findDiff(t, l + (l == 0 ? 0 : 1), 1 - D), A = u._findDiff(t, _, D);
          var N = 0;
          if (s == 1 && (N = i[w >>> 3] >>> 7 - (w & 7) & 1), s == 2 && (N = i[w >>> 3] >>> (w & 7) & 1), w++, v += N, y) {
            if (u._lens[D][v] != null) {
              var G = u._lens[D][v];
              v = "", n += G, G < 64 && (u._addNtimes(h, n, D), D = 1 - D, n = 0);
            }
          } else if (p == "H") {
            if (u._lens[D][v] != null) {
              var G = u._lens[D][v];
              v = "", n += G, G < 64 && (u._addNtimes(h, n, D), l += n, D = 1 - D, n = 0, x--, x == 0 && (p = ""));
            }
          } else
            v == "0001" && (v = "", u._addNtimes(h, A - l, D), l = A), v == "001" && (v = "", p = "H", x = 2), u._dmap[v] != null && (f = _ + u._dmap[v], u._addNtimes(h, f - l, D), l = f, v = "", D = 1 - D);
          v.endsWith("000000000001") && (B >= 0 && u._writeBits(h, d, c * 8 + B * S), s == 1 && (y = (i[w >>> 3] >>> 7 - (w & 7) & 1) == 1), s == 2 && (y = (i[w >>> 3] >>> (w & 7) & 1) == 1), w++, u._decodeG3.allow2D == null && (u._decodeG3.allow2D = y), u._decodeG3.allow2D || (y = !0, w--), v = "", D = 0, B++, l = 0, t = u._makeDiff(h), h = []);
        }
        h.length == o && u._writeBits(h, d, c * 8 + B * S);
      }, E.decode._addNtimes = function(i, r, a) {
        for (var d = 0; d < r; d++) i.push(a);
      }, E.decode._writeBits = function(i, r, a) {
        for (var d = 0; d < i.length; d++) r[a + d >>> 3] |= i[d] << 7 - (a + d & 7);
      }, E.decode._decodeLZW = function(i, r, a, d) {
        if (E.decode._lzwTab == null) {
          for (var c = new Uint32Array(65535), o = new Uint16Array(65535), v = new Uint8Array(2e6), s = 0; s < 256; s++)
            v[s << 2] = s, c[s] = s << 2, o[s] = 1;
          E.decode._lzwTab = [c, o, v];
        }
        for (var u = E.decode._copyData, w = E.decode._lzwTab[0], n = E.decode._lzwTab[1], v = E.decode._lzwTab[2], h = 258, t = 1032, e = 9, l = r << 3, f = 256, _ = 257, A = 0, D = 0, B = 0; A = i[l >>> 3] << 16 | i[l + 8 >>> 3] << 8 | i[l + 16 >>> 3], D = A >> 24 - (l & 7) - e & (1 << e) - 1, l += e, D != _; ) {
          if (D == f) {
            if (e = 9, h = 258, t = 1032, A = i[l >>> 3] << 16 | i[l + 8 >>> 3] << 8 | i[l + 16 >>> 3], D = A >> 24 - (l & 7) - e & (1 << e) - 1, l += e, D == _) break;
            a[d] = D, d++;
          } else if (D < h) {
            var p = w[D], x = n[D];
            if (u(v, p, a, d, x), d += x, B >= h)
              w[h] = t, v[w[h]] = p[0], n[h] = 1, t = t + 1 + 3 & -4, h++;
            else {
              w[h] = t;
              var y = w[B], S = n[B];
              u(v, y, v, t, S), v[t + S] = v[p], S++, n[h] = S, h++, t = t + S + 3 & -4;
            }
            h + 1 == 1 << e && e++;
          } else {
            if (B >= h)
              w[h] = t, n[h] = 0, h++;
            else {
              w[h] = t;
              var y = w[B], S = n[B];
              u(v, y, v, t, S), v[t + S] = v[t], S++, n[h] = S, h++, u(v, t, a, d, S), d += S, t = t + S + 3 & -4;
            }
            h + 1 == 1 << e && e++;
          }
          B = D;
        }
      }, E.decode._copyData = function(i, r, a, d, c) {
        for (var o = 0; o < c; o += 4)
          a[d + o] = i[r + o], a[d + o + 1] = i[r + o + 1], a[d + o + 2] = i[r + o + 2], a[d + o + 3] = i[r + o + 3];
      }, E.tags = {}, E.ttypes = { 256: 3, 257: 3, 258: 3, 259: 3, 262: 3, 273: 4, 274: 3, 277: 3, 278: 4, 279: 4, 282: 5, 283: 5, 284: 3, 286: 5, 287: 5, 296: 3, 305: 2, 306: 2, 338: 3, 513: 4, 514: 4, 34665: 4 }, E._readIFD = function(i, r, a, d, c, o) {
        var s = i.readUshort(r, a);
        a += 2;
        var u = {};
        d.push(u), o && z("   ".repeat(c), d.length - 1, ">>>----------------");
        for (var w = 0; w < s; w++) {
          var n = i.readUshort(r, a);
          a += 2;
          var v = i.readUshort(r, a);
          a += 2;
          var h = i.readUint(r, a);
          a += 4;
          var t = i.readUint(r, a);
          a += 4;
          var e = [];
          if ((v == 1 || v == 7) && (e = new Uint8Array(r.buffer, h < 5 ? a - 4 : t, h)), v == 2) {
            var l = h < 5 ? a - 4 : t, f = r[l];
            f < 128 ? e.push(i.readASCII(r, l, h - 1)) : e = new Uint8Array(r.buffer, l, h - 1);
          }
          if (v == 3)
            for (var _ = 0; _ < h; _++) e.push(i.readUshort(r, (h < 3 ? a - 4 : t) + 2 * _));
          if (v == 4)
            for (var _ = 0; _ < h; _++) e.push(i.readUint(r, (h < 2 ? a - 4 : t) + 4 * _));
          if (v == 5)
            for (var _ = 0; _ < h; _++) e.push(i.readUint(r, t + _ * 8) / i.readUint(r, t + _ * 8 + 4));
          if (v == 8)
            for (var _ = 0; _ < h; _++) e.push(i.readShort(r, (h < 3 ? a - 4 : t) + 2 * _));
          if (v == 9)
            for (var _ = 0; _ < h; _++) e.push(i.readInt(r, (h < 2 ? a - 4 : t) + 4 * _));
          if (v == 10)
            for (var _ = 0; _ < h; _++) e.push(i.readInt(r, t + _ * 8) / i.readInt(r, t + _ * 8 + 4));
          if (v == 11)
            for (var _ = 0; _ < h; _++) e.push(i.readFloat(r, t + _ * 4));
          if (v == 12)
            for (var _ = 0; _ < h; _++) e.push(i.readDouble(r, t + _ * 8));
          if (u["t" + n] = e, h != 0 && e.length == 0 && z("unknown TIFF tag type: ", v, "num:", h), o && z("   ".repeat(c), n, v, E.tags[n], e), !(n == 330 && u.t272 && u.t272[0] == "DSLR-A100")) {
            if (n == 330 || n == 34665 || n == 50740 && i.readUshort(r, i.readUint(e, 0)) < 300) {
              for (var A = n == 50740 ? [i.readUint(e, 0)] : e, D = [], _ = 0; _ < A.length; _++) E._readIFD(i, r, A[_], D, c + 1, o);
              n == 330 && (u.subIFD = D), n == 34665 && (u.exifIFD = D[0]), n == 50740 && (u.dngPrvt = D[0]);
            }
          }
          if (n == 37500) {
            var B = e;
            if (i.readASCII(B, 0, 5) == "Nikon") u.makerNote = E.decode(B.slice(10).buffer)[0];
            else if (i.readUshort(r, t) < 300) {
              var p = [];
              E._readIFD(i, r, t, p, c + 1, o), u.makerNote = p[0];
            }
          }
        }
        return o && z("   ".repeat(c), "<<<---------------"), a;
      }, E._writeIFD = function(i, r, a, d) {
        var c = Object.keys(d);
        i.writeUshort(r, a, c.length), a += 2;
        for (var o = a + c.length * 12 + 4, s = 0; s < c.length; s++) {
          var u = c[s], w = parseInt(u.slice(1)), n = E.ttypes[w];
          if (n == null) throw new Error("unknown type of tag: " + w);
          var v = d[u];
          n == 2 && (v = v[0] + "\0");
          var h = v.length;
          i.writeUshort(r, a, w), a += 2, i.writeUshort(r, a, n), a += 2, i.writeUint(r, a, h), a += 4;
          var t = [-1, 1, 1, 2, 4, 8, 0, 0, 0, 0, 0, 0, 8][n] * h, e = a;
          if (t > 4 && (i.writeUint(r, a, o), e = o), n == 2 && i.writeASCII(r, e, v), n == 3)
            for (var l = 0; l < h; l++) i.writeUshort(r, e + 2 * l, v[l]);
          if (n == 4)
            for (var l = 0; l < h; l++) i.writeUint(r, e + 4 * l, v[l]);
          if (n == 5)
            for (var l = 0; l < h; l++)
              i.writeUint(r, e + 8 * l, Math.round(v[l] * 1e4)), i.writeUint(r, e + 8 * l + 4, 1e4);
          if (n == 12)
            for (var l = 0; l < h; l++) i.writeDouble(r, e + 8 * l, v[l]);
          t > 4 && (t += t & 1, o += t), a += 4;
        }
        return [a, o];
      }, E.toRGBA8 = function(i) {
        var r = i.width, a = i.height, d = r * a, c = d * 4, o = i.data, s = new Uint8Array(d * 4), u = i.t262 ? i.t262[0] : 2, w = i.t258 ? Math.min(32, i.t258[0]) : 1;
        if (u == 0)
          for (var n = Math.ceil(w * r / 8), v = 0; v < a; v++) {
            var h = v * n, t = v * r;
            if (w == 1) for (var e = 0; e < r; e++) {
              var l = t + e << 2, f = o[h + (e >> 3)] >> 7 - (e & 7) & 1;
              s[l] = s[l + 1] = s[l + 2] = (1 - f) * 255, s[l + 3] = 255;
            }
            if (w == 4) for (var e = 0; e < r; e++) {
              var l = t + e << 2, f = o[h + (e >> 1)] >> 4 - 4 * (e & 1) & 15;
              s[l] = s[l + 1] = s[l + 2] = (15 - f) * 17, s[l + 3] = 255;
            }
            if (w == 8) for (var e = 0; e < r; e++) {
              var l = t + e << 2, f = o[h + e];
              s[l] = s[l + 1] = s[l + 2] = 255 - f, s[l + 3] = 255;
            }
          }
        else if (u == 1)
          for (var n = Math.ceil(w * r / 8), v = 0; v < a; v++) {
            var h = v * n, t = v * r;
            if (w == 1) for (var e = 0; e < r; e++) {
              var l = t + e << 2, f = o[h + (e >> 3)] >> 7 - (e & 7) & 1;
              s[l] = s[l + 1] = s[l + 2] = f * 255, s[l + 3] = 255;
            }
            if (w == 2) for (var e = 0; e < r; e++) {
              var l = t + e << 2, f = o[h + (e >> 2)] >> 6 - 2 * (e & 3) & 3;
              s[l] = s[l + 1] = s[l + 2] = f * 85, s[l + 3] = 255;
            }
            if (w == 8) for (var e = 0; e < r; e++) {
              var l = t + e << 2, f = o[h + e];
              s[l] = s[l + 1] = s[l + 2] = f, s[l + 3] = 255;
            }
            if (w == 16) for (var e = 0; e < r; e++) {
              var l = t + e << 2, f = o[h + (2 * e + 1)];
              s[l] = s[l + 1] = s[l + 2] = Math.min(255, f), s[l + 3] = 255;
            }
          }
        else if (u == 2) {
          var _ = i.t258 ? i.t258.length : 3;
          if (w == 8) {
            if (_ == 4) for (var e = 0; e < c; e++) s[e] = o[e];
            if (_ == 3) for (var e = 0; e < d; e++) {
              var l = e << 2, A = e * 3;
              s[l] = o[A], s[l + 1] = o[A + 1], s[l + 2] = o[A + 2], s[l + 3] = 255;
            }
          } else {
            if (_ == 4) for (var e = 0; e < d; e++) {
              var l = e << 2, A = e * 8 + 1;
              s[l] = o[A], s[l + 1] = o[A + 2], s[l + 2] = o[A + 4], s[l + 3] = o[A + 6];
            }
            if (_ == 3) for (var e = 0; e < d; e++) {
              var l = e << 2, A = e * 6 + 1;
              s[l] = o[A], s[l + 1] = o[A + 2], s[l + 2] = o[A + 4], s[l + 3] = 255;
            }
          }
        } else if (u == 3)
          for (var D = i.t320, e = 0; e < d; e++) {
            var l = e << 2, B = o[e];
            s[l] = D[B] >> 8, s[l + 1] = D[256 + B] >> 8, s[l + 2] = D[512 + B] >> 8, s[l + 3] = 255;
          }
        else if (u == 5)
          for (var _ = i.t258 ? i.t258.length : 4, p = _ > 4 ? 1 : 0, e = 0; e < d; e++) {
            var l = e << 2, x = e * _, y = 255 - o[x], S = 255 - o[x + 1], N = 255 - o[x + 2], G = (255 - o[x + 3]) * (1 / 255);
            s[l] = ~~(y * G + 0.5), s[l + 1] = ~~(S * G + 0.5), s[l + 2] = ~~(N * G + 0.5), s[l + 3] = 255 * (1 - p) + o[x + 4] * p;
          }
        else z("Unknown Photometric interpretation: " + u);
        return s;
      }, E.replaceIMG = function(i) {
        i == null && (i = document.getElementsByTagName("img"));
        for (var r = ["tif", "tiff", "dng", "cr2", "nef"], a = 0; a < i.length; a++) {
          var d = i[a], c = d.getAttribute("src");
          if (c != null) {
            var o = c.split(".").pop().toLowerCase();
            if (r.indexOf(o) != -1) {
              var s = new XMLHttpRequest();
              E._xhrs.push(s), E._imgs.push(d), s.open("GET", c), s.responseType = "arraybuffer", s.onload = E._imgLoaded, s.send();
            }
          }
        }
      }, E._xhrs = [], E._imgs = [], E._imgLoaded = function(i) {
        var r = i.target.response, a = E.decode(r), d = a, c = 0, o = d[0];
        a[0].subIFD && (d = d.concat(a[0].subIFD));
        for (var s = 0; s < d.length; s++) {
          var t = d[s];
          if (!(t.t258 == null || t.t258.length < 3)) {
            var u = t.t256 * t.t257;
            u > c && (c = u, o = t);
          }
        }
        E.decodeImage(r, o, a);
        var w = E.toRGBA8(o), n = o.width, v = o.height, h = E._xhrs.indexOf(i.target), t = E._imgs[h];
        E._xhrs.splice(h, 1), E._imgs.splice(h, 1);
        var e = document.createElement("canvas");
        e.width = n, e.height = v;
        for (var l = e.getContext("2d"), f = l.createImageData(n, v), s = 0; s < w.length; s++) f.data[s] = w[s];
        l.putImageData(f, 0, 0), t.setAttribute("src", e.toDataURL());
      }, E._binBE = {
        nextZero: function(i, r) {
          for (; i[r] != 0; ) r++;
          return r;
        },
        readUshort: function(i, r) {
          return i[r] << 8 | i[r + 1];
        },
        readShort: function(i, r) {
          var a = E._binBE.ui8;
          return a[0] = i[r + 1], a[1] = i[r + 0], E._binBE.i16[0];
        },
        readInt: function(i, r) {
          var a = E._binBE.ui8;
          return a[0] = i[r + 3], a[1] = i[r + 2], a[2] = i[r + 1], a[3] = i[r + 0], E._binBE.i32[0];
        },
        readUint: function(i, r) {
          var a = E._binBE.ui8;
          return a[0] = i[r + 3], a[1] = i[r + 2], a[2] = i[r + 1], a[3] = i[r + 0], E._binBE.ui32[0];
        },
        readASCII: function(i, r, a) {
          for (var d = "", c = 0; c < a; c++) d += String.fromCharCode(i[r + c]);
          return d;
        },
        readFloat: function(i, r) {
          for (var a = E._binBE.ui8, d = 0; d < 4; d++) a[d] = i[r + 3 - d];
          return E._binBE.fl32[0];
        },
        readDouble: function(i, r) {
          for (var a = E._binBE.ui8, d = 0; d < 8; d++) a[d] = i[r + 7 - d];
          return E._binBE.fl64[0];
        },
        writeUshort: function(i, r, a) {
          i[r] = a >> 8 & 255, i[r + 1] = a & 255;
        },
        writeUint: function(i, r, a) {
          i[r] = a >> 24 & 255, i[r + 1] = a >> 16 & 255, i[r + 2] = a >> 8 & 255, i[r + 3] = a >> 0 & 255;
        },
        writeASCII: function(i, r, a) {
          for (var d = 0; d < a.length; d++) i[r + d] = a.charCodeAt(d);
        },
        writeDouble: function(i, r, a) {
          E._binBE.fl64[0] = a;
          for (var d = 0; d < 8; d++) i[r + d] = E._binBE.ui8[7 - d];
        }
      }, E._binBE.ui8 = new Uint8Array(8), E._binBE.i16 = new Int16Array(E._binBE.ui8.buffer), E._binBE.i32 = new Int32Array(E._binBE.ui8.buffer), E._binBE.ui32 = new Uint32Array(E._binBE.ui8.buffer), E._binBE.fl32 = new Float32Array(E._binBE.ui8.buffer), E._binBE.fl64 = new Float64Array(E._binBE.ui8.buffer), E._binLE = {
        nextZero: E._binBE.nextZero,
        readUshort: function(i, r) {
          return i[r + 1] << 8 | i[r];
        },
        readShort: function(i, r) {
          var a = E._binBE.ui8;
          return a[0] = i[r + 0], a[1] = i[r + 1], E._binBE.i16[0];
        },
        readInt: function(i, r) {
          var a = E._binBE.ui8;
          return a[0] = i[r + 0], a[1] = i[r + 1], a[2] = i[r + 2], a[3] = i[r + 3], E._binBE.i32[0];
        },
        readUint: function(i, r) {
          var a = E._binBE.ui8;
          return a[0] = i[r + 0], a[1] = i[r + 1], a[2] = i[r + 2], a[3] = i[r + 3], E._binBE.ui32[0];
        },
        readASCII: E._binBE.readASCII,
        readFloat: function(i, r) {
          for (var a = E._binBE.ui8, d = 0; d < 4; d++) a[d] = i[r + d];
          return E._binBE.fl32[0];
        },
        readDouble: function(i, r) {
          for (var a = E._binBE.ui8, d = 0; d < 8; d++) a[d] = i[r + d];
          return E._binBE.fl64[0];
        }
      }, E._copyTile = function(i, r, a, d, c, o, s, u) {
        for (var w = Math.min(r, c - s), n = Math.min(a, o - u), v = 0; v < n; v++)
          for (var h = (u + v) * c + s, t = v * r, e = 0; e < w; e++) d[h + e] = i[t + e];
      }, E.LosslessJpegDecode = function() {
        function i(c) {
          this.w = c, this.N = 0, this._ = 0, this.G = 0;
        }
        i.prototype = { t: function(c) {
          this.N = Math.max(0, Math.min(this.w.length, c));
        }, i: function() {
          return this.w[this.N++];
        }, l: function() {
          var c = this.N;
          return this.N += 2, this.w[c] << 8 | this.w[c + 1];
        }, J: function() {
          return this._ == 0 && (this.G = this.w[this.N], this.N += 1 + (this.G + 1 >>> 8), this._ = 8), this.G >>> --this._ & 1;
        }, Z: function(c) {
          var o = this._, s = this.G, u = Math.min(o, c);
          c -= u, o -= u;
          for (var w = s >>> o & (1 << u) - 1; c > 0; )
            s = this.w[this.N], this.N += 1 + (s + 1 >>> 8), u = Math.min(8, c), c -= u, o = 8 - u, w <<= u, w |= s >>> o & (1 << u) - 1;
          return this._ = o, this.G = s, w;
        } };
        var r = {};
        r.X = function() {
          return [0, 0, -1];
        }, r.s = function(c, o, s) {
          c[r.Y(c, 0, s) + 2] = o;
        }, r.Y = function(c, o, s) {
          if (c[o + 2] != -1) return 0;
          if (s == 0) return o;
          for (var u = 0; u < 2; u++) {
            c[o + u] == 0 && (c[o + u] = c.length, c.push(0), c.push(0), c.push(-1));
            var w = r.Y(c, c[o + u], s - 1);
            if (w != 0) return w;
          }
          return 0;
        }, r.B = function(c, o) {
          for (var s = 0, u = 0, w = 0, n = o._, v = o.G, h = o.N; ; )
            if (n == 0 && (v = o.w[h], h += 1 + (v + 1 >>> 8), n = 8), w = v >>> --n & 1, s = c[s + w], u = c[s + 2], u != -1)
              return o._ = n, o.G = v, o.N = h, u;
          return -1;
        };
        function a(c) {
          this.z = new i(c), this.D(this.z);
        }
        a.prototype = { $: function(c, o) {
          this.Q = c.i(), this.F = c.l(), this.o = c.l();
          var s = this.O = c.i();
          this.L = [];
          for (var u = 0; u < s; u++) {
            var w = c.i();
            c.i(), c.i(), this.L[w] = u;
          }
          c.t(c.N + o - (6 + s * 3));
        }, e: function() {
          var c = 0, o = this.z.i();
          this.H == null && (this.H = {});
          for (var s = this.H[o] = r.X(), u = [], w = 0; w < 16; w++)
            u[w] = this.z.i(), c += u[w];
          for (var w = 0; w < 16; w++) for (var n = 0; n < u[w]; n++) r.s(s, this.z.i(), w + 1);
          return c + 17;
        }, W: function(c) {
          for (; c > 0; ) c -= this.e();
        }, p: function(c, o) {
          var s = c.i();
          this.U || (this.U = []);
          for (var u = 0; u < s; u++) {
            var w = c.i(), n = c.i();
            this.U[this.L[w]] = this.H[n >>> 4];
          }
          this.g = c.i(), c.t(c.N + o - (2 + s * 2));
        }, D: function(c) {
          var o = !1, s = c.l();
          if (s === a.q)
            do {
              var s = c.l(), u = c.l() - 2;
              switch (s) {
                case a.m:
                  this.$(c, u);
                  break;
                case a.K:
                  this.W(u);
                  break;
                case a.V:
                  this.p(c, u), o = !0;
                  break;
                default:
                  c.t(c.N + u);
                  break;
              }
            } while (!o);
        }, I: function(c, o) {
          var s = r.B(o, c);
          if (s == 16) return -32768;
          var u = c.Z(s);
          return u & 1 << s - 1 || (u -= (1 << s) - 1), u;
        }, B: function(c, o) {
          for (var s = this.z, u = this.O, w = this.F, n = this.I, v = this.g, h = this.o * u, t = this.U, e = 0; e < u; e++)
            c[e] = n(s, t[e]) + (1 << this.Q - 1);
          for (var l = u; l < h; l += u)
            for (var e = 0; e < u; e++) c[l + e] = n(s, t[e]) + c[l + e - u];
          for (var f = o, _ = 1; _ < w; _++) {
            for (var e = 0; e < u; e++)
              c[f + e] = n(s, t[e]) + c[f + e - o];
            for (var l = u; l < h; l += u)
              for (var e = 0; e < u; e++) {
                var A = f + l + e, D = c[A - u];
                v == 6 && (D = c[A - o] + (D - c[A - u - o] >>> 1)), c[A] = D + n(s, t[e]);
              }
            f += o;
          }
        } }, a.m = 65475, a.K = 65476, a.q = 65496, a.V = 65498;
        function d(c) {
          var o = new a(c), s = o.Q > 8 ? Uint16Array : Uint8Array, u = new s(o.o * o.F * o.O), w = o.o * o.O;
          return o.B(u, w), u;
        }
        return d;
      }();
    })(F, U);
  })();
})(n0);
var c0 = n0.exports;
export {
  c0 as U
};
//# sourceMappingURL=UTIF.es.js.map
